export const envConfig = {
  apiUrl: import.meta.env.VITE_API_URL || 'https://api.classquiz.tn/v3',
  apiUrlAnalysis: import.meta.env.VITE_API_URL_ANALYSIS || 'https://analysis.classquiz.tn/',
  apiUrlAi: import.meta.env.VITE_API_AI_URL || 'https://api-assistant.classquiz.tn/',
  socketUrl: import.meta.env.VITE_SOCKET_URL || 'wss://realtime.classquiz.tn',
  iconUrl: import.meta.env.VITE_ICON_URL || 'https://api.classquiz.tn/uploads/icons/',

  isDev: import.meta.env.MODE === 'development',
  isProd: import.meta.env.MODE === 'production',
  mode: import.meta.env.MODE,
};

export default envConfig;
